import { timeSupervision } from "../../../AxiosRtk/DashBoard";
import { AlertModal } from "../../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../../setup/alert/iconTypes";
import { useSelector, useDispatch } from "react-redux";
import useFirebase from "../../../../../useFirebase";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
// import { setRuleTimeSupervisionData } from '../../../AxiosRtk/SetRules';

function useTimeSupervision() {
  const dispatch = useDispatch();

  const { setRulesData, timeSupervisionData } = useSelector(
    ({ setRules }) => setRules
  );

  const { postCollectionData, getCollectionData } = useFirebase();
  // const [deviceId, setDeviceId] = useState(null);
  const { selectedKidId } = useSelector(({ dashboard }) => dashboard);

  function convertTimeFormat(time) {
    if(time) {
      const [hours, minutes, seconds] = time.split(":");
      return `${hours}:${minutes}`;
    }
    return time
  }

  function getScheduleData(schedule) {
    console.log(schedule)
    const days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    const dayMap = new Map();

    days.forEach((day) => {
      dayMap.set(day, []);
      schedule?.forEach((sch) => {
        if (sch?.day === day) {
          const value = dayMap.get(day);
          value.push({
            startTime: convertTimeFormat(sch?.startTime),
            endTime: convertTimeFormat(sch?.endTime),
          });
          dayMap.set(day, value);
        }
      });
    });

    const dayMapArr = Array.from(dayMap, ([key, value]) => ({ key, value }));
    return [...dayMapArr];
  }

  function getDailyLimitSelectedDays(dailyLimitSelectedDays, scheduleData) {
    // console.log("dailyLimitSelectedDays", dailyLimitSelectedDays);
    scheduleData?.forEach((item, index) => {
      scheduleData[index]["isDaySelected"] =
        dailyLimitSelectedDays[
          item?.key[0]?.toLowerCase() + item?.key?.slice(1)
        ];
    });
    return scheduleData;
  }

  function getDailyLimit(dailyLimit) {
    const newTempObj = {};
    for (let key in dailyLimit) {
      if (dailyLimit.hasOwnProperty(key)) {
        const capitalizeWord = key[0]?.toUpperCase() + key?.substring(1);
        newTempObj[capitalizeWord] = dailyLimit[key];
      }
    }

    return newTempObj;
  }

  function timeSupervisionApi(payload) {
    setTimeout(() => {
      timeSupervision(payload)
        .then((res) => {
          {
            /*  AlertModal("Schedule updated", alertIconType?.successIcon);*/
          }

          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: "Updated Successfully",
              message: "UPDATED_SUCCESS",
            })
          );
        })
        .then(() => {})
        .catch((err) => {
          console.log(
            "get time supervision data catch error ===>>",
            err?.response?.data?.message
          );
        });
    }, 600);
  }

  function handleScheduleDataToggleChange(
    e,
    scheduleData,
    setScheduleData,
    deviceId,
    time,
    daySelect
  ) {
    // console.log("scheduleData ==>>", scheduleData)
    const { name, checked } = e.target;
    const tempSchData = [...scheduleData];
    tempSchData.forEach((item, index) => {
      if (item?.key === name?.toLowerCase()) {
        tempSchData[index]["isDaySelected"] = checked ? 1 : 0;
      }
    });
    // setScheduleData(tempSchData);

    // console.log("tempSchData =>", tempSchData)
    const dailyLimitSelectedDays = {};
    const dailyLimitSelectedDaysCollectionPayload = {};

    tempSchData?.forEach((temp) => {
      dailyLimitSelectedDays[
        `${temp?.key[0]?.toUpperCase()}${temp?.key?.slice(1)}`
      ] = temp?.isDaySelected ?? 0;
      dailyLimitSelectedDaysCollectionPayload[temp?.key] =
        temp?.isDaySelected ?? 0;
    });

    const payload = {
      kidId: selectedKidId,
      deviceId,
      dailyLimitSelectedDays,
      dailyLimitSeekBarProgress: 0,
    };

    const collectionPayload = {
      ...setRulesData?.timesupervison,
      dailyLimitSelectedDays: dailyLimitSelectedDaysCollectionPayload,
    };

    // console.log("collectionPayload ==>>", collectionPayload)
    postCollectionData(deviceId, { timesupervison: collectionPayload });
    getCollectionData(deviceId);
    timeSupervisionApi(payload);
  }

  function getSlotData(time, daySelect) {
    const startTime = time?.stm;
    const endTime = time?.etm;

    const slots = [
      { day: "monday", startTime, endTime, IsDelete: 0, IsInsert: 1 },
      { day: "tuesday", startTime, endTime, IsDelete: 0, IsInsert: 1 },
      { day: "wednesday", startTime, endTime, IsDelete: 0, IsInsert: 1 },
      { day: "thursday", startTime, endTime, IsDelete: 0, IsInsert: 1 },
      { day: "friday", startTime, endTime, IsDelete: 0, IsInsert: 1 },
      { day: "saturday", startTime, endTime, IsDelete: 0, IsInsert: 1 },
      { day: "sunday", startTime, endTime, IsDelete: 0, IsInsert: 1 },
    ];

    switch (daySelect) {
      case "EVERYDAY":
        return slots;
      case "WEEKDAYS":
        return slots?.slice(0, 5);
      case "WEEKEND":
        return slots?.slice(5, 7);
      case "MONDAY":
        return slots?.slice(0, 1);
      case "TUESDAY":
        return slots?.slice(1, 2);
      case "WEDNESDAY":
        return slots?.slice(2, 3);
      case "THURSDAY":
        return slots?.slice(3, 4);
      case "FRIDAY":
        return slots?.slice(4, 5);
      case "SATURDAY":
        return slots?.slice(5, 6);
      case "SUNDAY":
        return slots?.slice(6, 7);
      default:
        return slots;
    }
  }

  async function getTimeSuperVisionData(
    deviceId,
    collection = "SetRuleDataModel"
  ) {
    await getCollectionData(deviceId, collection);
  }

  function handleTimeRemove(
    day,
    startTime,
    endTime,
    scheduleData,
    setScheduleData,
    deviceId
  ) {
    let schData = [...scheduleData];
    // console.log(schData)
    const dayData = schData?.find((item) => item?.key === day);
    // console.log(dayData)

    const dataArrVal = [...dayData?.value];
    const indexToRemove = dataArrVal?.findIndex(
      (obj) => obj?.startTime === startTime && obj?.endTime === endTime
    );
    // console.log(indexToRemove)

    dataArrVal?.splice(indexToRemove, 1);
    // console.log(dataArrVal)

    schData = schData?.map((item) => {
      if (item?.key === day) {
        return {
          key: item?.key,
          value: dataArrVal,
          isDaySelected: item?.isDaySelected,
        };
      }

      return item;
    });
    // console.log(schData)
    // setScheduleData(schData);
    // schData = schData?.find((item) => item?.key === day);
    const scheduleDelete = [
      { day, startTime, endTime, IsDelete: 1, IsInsert: 0 },
    ];

    const payload = {
      kidId: selectedKidId,
      deviceId,
      Schedule: scheduleDelete,
      dailyLimitSeekBarProgress: 0,
    };

    const schedulePayload = [];

    schData?.forEach((outer) => {
      [...outer?.value]?.forEach((inner) => {
        const tempObj = {
          day: outer?.key,
          isInsert: 1,
          isDelete: 0,
          startTime: inner?.startTime,
          endTime: inner?.endTime,
          id: Math.floor(Math.random() * Math.pow(10, 6)),
        };

        schedulePayload.push(tempObj);
      });
    });
    // console.log(schedulePayload)

    const collectionPayload = {
      ...setRulesData?.timesupervison,
      schedule: schedulePayload,
    };

    postCollectionData(deviceId, { timesupervison: collectionPayload });
    getCollectionData(deviceId);
    timeSupervisionApi(payload);
    // }
  }

  function keyStrokesModifiedData(keyStrokeData) {
    const keyStrokeFormattedData = [];
    let newList = [];

    keyStrokeData?.forEach((item, index) => {
      if (index % 3 === 0) {
        if (newList?.length > 0) {
          keyStrokeFormattedData.push([[...newList]]);
          newList.length = 0;
        }
        newList.push(item);
      } else {
        newList.push(item);
      }
    });

    if (newList?.length > 0) {
      keyStrokeFormattedData.push([[...newList]]);
      newList.length = 0;
    }

    return [...keyStrokeFormattedData];
  }

  function mergeTimeSlots(slots) {
    // Sort slots by day and start time
    slots.sort((a, b) => {
      if (a.day !== b.day) {
        return a.day.localeCompare(b.day);
      }
      return (
        new Date("1970/01/01 " + a.startTime) -
        new Date("1970/01/01 " + b.startTime)
      );
    });

    let mergedSlots = [];
    let currentDay = null;
    let currentSlot = null;

    slots.forEach((slot) => {
      if (currentDay !== slot.day) {
        // If new day, push currentSlot if exists
        if (currentSlot) {
          mergedSlots.push(currentSlot);
        }
        currentDay = slot.day;
        currentSlot = { ...slot };
      } else if (!currentSlot || slot.startTime > currentSlot.endTime) {
        // If no current slot or current slot ends before the next one starts, push currentSlot and update currentSlot
        if (currentSlot) {
          mergedSlots.push(currentSlot);
        }
        currentSlot = { ...slot };
      } else if (slot.endTime > currentSlot.endTime) {
        // If current slot overlaps with the next one, update currentSlot's endTime
        currentSlot.endTime = slot.endTime;
      }
    });

    // Add last currentSlot to mergedSlots if exists
    if (currentSlot) {
      mergedSlots.push(currentSlot);
    }

    return mergedSlots;
  }

  return {
    getScheduleData,
    getDailyLimitSelectedDays,
    handleScheduleDataToggleChange,
    timeSupervisionApi,
    getDailyLimit,
    getTimeSuperVisionData,
    handleTimeRemove,
    keyStrokesModifiedData,
    postCollectionData,
    getSlotData,
    mergeTimeSlots,
  };
}

export default useTimeSupervision;
